var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fb-form-properties-manager',{attrs:{"id":"patient-dispense-report-v1-properties-yelb8b","fields":_vm.fields,"formId":_vm.formId}})
}
var staticRenderFns = []

export { render, staticRenderFns }